import React from 'react';
import Text from 'Components/Text';
import moment from 'moment';
import { INSPECTION_STATUS } from 'constants/index';

export default function GeneralInformation({
  user,
  status,
  description,
  inspectionDate,
  year,
  inspector,
  approvalDate,
  address,
}) {
  return (
    <section className='scene_section _padding_top_0'>
      <header>General Info</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _width_pc_100'
        textClassName='text__text_primary'
        label='Description'
        alwaysTextField
        value={description}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Inspection Date'
        value={moment(inspectionDate).local(true).format('MM / DD / YYYY')}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Inspector name'
        value={inspector ? `${inspector.firstName} ${inspector.lastName}` : 'NMMA Inspector'}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary  _width_pc_100'
        textClassName='text__text_primary'
        label='Model Year'
        value={year}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary  _width_pc_100'
        textClassName='text__text_primary'
        label='Address'
        value={address}
      />
      {status === INSPECTION_STATUS.COMPLETE && (
        <Text
          mainWrapperClassName='text__wrapper_primary  _width_pc_100'
          textClassName='text__text_primary'
          label='Approval date'
          value={approvalDate ? moment(approvalDate).local(true).format('MM / DD / YYYY') : 'N/A'}
        />
      )}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Details/Report/GeneralInformation.jsx